export default __webpack_public_path__ + "static/media/belop_cropped.ae1cc2b5.png";